export const GET_FEED = "GET_FEED";
export const GET_ACCESSTOKEN = "GET_ACCESSTOKEN";
